export const fr_overrides_strings = {
  'err.phone_nr.pattern': 'Numéro de téléphone invalide. Formats acceptés: numéro local (10 chiffres) OU numéro international (avec indicatif de pays commençant pas + ou 00)'
};
